import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing an icon symbolizing new releases.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <NewReleaseIcon width={12} />
 */
const NewReleaseIcon = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path d="M22.34,12.75l-1.77,2.03l0.24,2.68c0.05,0.55-0.35,1.1-0.89,1.22l-2.63,0.6l-1.39,2.31c-0.28,0.47-0.93,0.68-1.43,0.47  L12,21.02l-2.48,1.05c-0.51,0.22-1.15,0.01-1.43-0.47L6.7,19.29l-2.63-0.6c-0.54-0.12-0.93-0.67-0.89-1.22l0.24-2.68l-1.77-2.03  c-0.36-0.41-0.36-1.09,0-1.51l1.77-2.03L3.19,6.53c-0.05-0.55,0.35-1.1,0.89-1.22l2.62-0.6L8.09,2.4c0.28-0.47,0.93-0.68,1.43-0.47  L12,2.98l2.48-1.05c0.51-0.22,1.15-0.01,1.43,0.47l1.39,2.31l2.63,0.6c0.54,0.12,0.93,0.67,0.89,1.22l-0.24,2.68l1.77,2.03  C22.7,11.66,22.7,12.34,22.34,12.75z M13,8c0-0.55-0.45-1-1-1s-1,0.45-1,1v4c0,0.55,0.45,1,1,1s1-0.45,1-1V8z M13,15h-2v2h2V15z" />
    </SvgIcon>
)

NewReleaseIcon.defaultProps = defaultProps

export { NewReleaseIcon }
